@if (isLoading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div id="team-decision-section" class="clearfix">
  <div class="horizontal-title team-decission-title">
    Team Decision <button mat-icon-button class="compact" matTooltip="Refresh" (click)="refreshPendingCards()"><mat-icon>sync</mat-icon></button>
  </div>
  <app-teamdecision-card [stopSide]="'right'" [followUpId]="1" [followUpCategoryId]="1" [cardId]="'newleads'"
  [cardList]="teamDecisionsNewlead$ | async" [cardHeading]="'New Lead'" [showLeadSource]="true"></app-teamdecision-card>
  <app-teamdecision-card [stopSide]="'right'" [followUpId]="2" [followUpCategoryId]="2" [cardId]="'noshow'"
  [cardList]="teamDecisionsNoshow$ | async" [cardHeading]="'No Show'"></app-teamdecision-card>
  <app-teamdecision-card [stopSide]="'right'" [followUpId]="3" [followUpCategoryId]="3" [cardId]="'recall'"
  [cardList]="teamDecisionsRecall$ | async" [cardHeading]="'Recall'" [disabled]="recallDisabledMsg">
    <button mat-icon-button (click)="openBrandRecallSettingsDialog()" style="margin: -50% 0" matTooltip="Edit Recall Settings"><mat-icon>edit</mat-icon></button>
  </app-teamdecision-card>
  <app-teamdecision-card [stopSide]="'right'" [followUpId]="4" [followUpCategoryId]="4" [cardId]="'pending'"
  [cardList]="teamDecisionsPending$ | async" [cardHeading]="'Pending'"></app-teamdecision-card>
  <app-teamdecision-card [stopSide]="'left'" [followUpId]="5" [followUpCategoryId]="5" [cardId]="'misc'"
  [cardList]="teamDecisionsMisc$ | async" [cardHeading]="'Misc'"></app-teamdecision-card>
  <!-- TODO: UNCOMMENT WHEN BACKEND IS COMPLETE-->
  <!-- <app-ava-contribution></app-ava-contribution> -->
</div>
<div id="avas-patients-section" class="clearfix" style="margin-top: 60px; margin-bottom: 50px; position:relative;">
  <div class="horizontal-title avap-win-present">
    Ava’s Patients <button mat-icon-button matTooltip="Refresh" (click)="refreshAvaCards()"><mat-icon>sync</mat-icon></button>
  </div>
  <img class="absolute-bg-contact-image" src="./assets/images/contact_icon_left.png">
  <app-avapatient-card [stopSide]="'right'" [followUpId]="1" [followUpCategoryId]="1" [cardId]="'newleads'"
    [cardList]="avaPatientNewlead$ | async" [cardHeading]="'New Leads'" [wins]="wins.newlead"
    [consultants]="consultants$ | async" [redgraycount]="avaPatientNewleadCount$ | async"
    (onItemSelected)="pationCardItemSelected($event)" [itemSelectedNotification]="actionAvaPatientMenu.asObservable()">
  </app-avapatient-card>
  <app-avapatient-card [stopSide]="'right'" [followUpId]="2" [followUpCategoryId]="2" [cardId]="'noshow'"
    [cardList]="avaPatientNoshow$ | async" [cardHeading]="'No Show'" [wins]="wins.noshow"
    [consultants]="consultants$ | async" [redgraycount]="avaPatientNoShowCount$ | async"
    (onItemSelected)="pationCardItemSelected($event)" [itemSelectedNotification]="actionAvaPatientMenu.asObservable()">
  </app-avapatient-card>
  <app-avapatient-card [stopSide]="'right'" [followUpId]="3" [followUpCategoryId]="3" [cardId]="'recall'"
    [cardList]="avaPatientRecall$ | async" [cardHeading]="'Recall'" [wins]="wins.recall"
    [consultants]="consultants$ | async" [redgraycount]="avaPatientRecallCount$ | async"
    (onItemSelected)="pationCardItemSelected($event)" [itemSelectedNotification]="actionAvaPatientMenu.asObservable()">
  </app-avapatient-card>
  <app-avapatient-card [stopSide]="'right'" [followUpId]="4" [followUpCategoryId]="4" [cardId]="'pending'"
    [cardList]="avaPatientPending$ | async" [cardHeading]="'Pending'" [wins]="wins.pending"
    [consultants]="consultants$ | async" [redgraycount]="avaPatientPendingCount$ | async"
    (onItemSelected)="pationCardItemSelected($event)" [itemSelectedNotification]="actionAvaPatientMenu.asObservable()">
  </app-avapatient-card>
  <app-avapatient-card [stopSide]="'left'" [followUpId]="5" [followUpCategoryId]="5" [cardId]="'misc'"
    [cardList]="avaPatientMisc$ | async" [cardHeading]="'Misc'" [wins]="wins.misc"
    [consultants]="consultants$ | async" [redgraycount]="avaPatientMisc$ | async"
    (onItemSelected)="pationCardItemSelected($event)" [itemSelectedNotification]="actionAvaPatientMenu.asObservable()">
  </app-avapatient-card>
</div>
